var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"editor-content-rendered",domProps:{"innerHTML":_vm._s(_vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }